import React from "react";
import TextInput from "../../../components/inputs/TextInput";
import DetailItem from "./DetailItem"; 
import style from "./CarInfo.module.scss";

const CarInfo = ({ car, isEditing, onCarChange }) => {
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const updatedValue = name === "year" || name === "mileage" ? Number(value) || null : value;
    onCarChange({ ...car, [name]: updatedValue });
  };

  return (
    <div className={style.carCard}>
      {isEditing ? (
        <>
          <TextInput label="Производитель" name="manufacturer" value={car.manufacturer || ""} onChange={handleInputChange} placeholder="Введите производителя" />
          <TextInput label="Модель" name="model" value={car.model || ""} onChange={handleInputChange} placeholder="Введите модель" />
          <TextInput label="Регистрационный номер" name="reg_number" value={car.reg_number || ""} onChange={handleInputChange} placeholder="Введите номер" />
          <TextInput label="VIN номер" name="vin_number" value={car.vin_number || ""} onChange={handleInputChange} placeholder="Введите VIN" />
          <TextInput label="Год выпуска" name="year" value={car.year || ""} onChange={handleInputChange} placeholder="Введите год" />
          <TextInput label="Пробег (км)" name="mileage" value={car.mileage || ""} onChange={handleInputChange} placeholder="Введите пробег" />
        </>
      ) : (
        <div className={style.detailsGrid}>
          <DetailItem label="Производитель" value={car.manufacturer} />
          <DetailItem label="Модель" value={car.model} />
          <DetailItem label="Регистрационный номер" value={car.reg_number} />
          <DetailItem label="VIN номер" value={car.vin_number} />
          <DetailItem label="Год выпуска" value={car.year} />
          <DetailItem label="Пробег (км)" value={car.mileage} />
          <DetailItem label="Дата создания" value={new Date(car.created_at).toLocaleDateString()} />
        </div>
      )}
    </div>
  );
};

export default CarInfo;
